import { DefaultButton, IconButton } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';
import { DataAlarme } from '../../data/DataAlarme';
import { DataMonCompte } from '../../data/DataMonCompte';
import { Immocom } from '../../specifique/immocom';
import { EUIModal } from '../EUI/EUIModal';
import { EUIPage } from '../EUI/EUIPage';
import { DetailsListAlarme } from '../List/DetailsListAlarme';

export class BackOfficeCapsuleClient extends Component {

    constructor(props) {
        super(props);

        this.state = {
            afficherModalAlarmes: false,
        }
    }

    _chargementDroitsLiesAuxAlarmes = () => {
        let chargementDroitsLiesAuxAlarmes = DataMonCompte._chargementDroitsLiesAuxAlarmes();
        chargementDroitsLiesAuxAlarmes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const droits = responseFetch.reponseAPIobjet;
                    const peutGererAlarmesCapsuleClient = droits.peutGererAlarmesCapsuleClient;
                    this.setState(
                        { peutGererAlarmesCapsuleClient }
                    );
                }
                else {
                    const stateTemp = { peutGererAlarmesCapsuleClient: false };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _getButtons = () => {
        let buttons = [];
        if (this.state.peutGererAlarmesCapsuleClient)
            buttons.push(<IconButton
                ariaLabel="Afficher les alarmes actives"
                iconProps={{ iconName: "Ringer" }}
                key="alarms"
                onClick={this._toggleModalAlarmes(true)}
                title="Afficher les alarmes"
            />);
        return buttons;
    };

    _toggleModalAlarmes = (isOpen) => () => {
        this.setState({ afficherModalAlarmes: isOpen });
    };

    componentDidMount = () => {
        this._chargementDroitsLiesAuxAlarmes();
    };

    render = () => {

        return <Fragment>

            <EUIPage
                baseUrl="/BackOfficeCapsuleClient"
                buttons={this._getButtons()}
                onglets={[
                    { url: "/CapsuleClient", titre: "Espace Client" }, //2378
                    { url: "/Actualites", titre: "Actualités" } //20230601 : YD : 2421
                ]}
            />
            <EUIModal
                buttons={[<DefaultButton key="close" onClick={this._toggleModalAlarmes(false)} text="Fermer" name="BoutonFermer" />]}
                isOpen={this.state.afficherModalAlarmes}
                onDismiss={this._toggleModalAlarmes(false)}
                titre="Alarmes actives">
                <DetailsListAlarme
                    activerCreation={false}
                    activerFiltres={false}
                    afficherAlarmesLieesACapsules
                    afficherAlarmesInactives={false}
                />
            </EUIModal>

        </Fragment>;

    }
}